import { render, staticRenderFns } from "./AddNewDropdown.vue?vue&type=template&id=82083636"
import script from "./AddNewDropdown.vue?vue&type=script&lang=js"
export * from "./AddNewDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports